
  import { Debounce } from '@/utils/decorators'
  import { fixPrice } from '@/utils/general'
  import dayjs from 'dayjs'
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import { Prop, Watch } from 'vue-property-decorator'

@Component({})
  export default class InspectionsReport extends Vue {
  @Prop() reports
  @Prop({ default: undefined, type: Number }) idExecutive
  executives = []
  reportsAttribute = []
  fixPrice = fixPrice
  dayjs = dayjs
  currentDate = dayjs()

  isConsignment (inspection: Record<string, any>) {
    const { lastAppraisedResponse, lastAppraisedConsignmentResponse, agreedAmount } = inspection
    const appraisedAmount = Number(lastAppraisedResponse?.amount)
    const consignmentAmount = Number(lastAppraisedConsignmentResponse?.amount)

    return Number(agreedAmount) > appraisedAmount ||
      (consignmentAmount && !appraisedAmount)
  }

  filterByExecutive (executive, id?) {
    if (id) {
      const filterById = this.reportsAttribute.filter(report => report.executive === id)
      executive = filterById?.[0]?.executiveName
    }
    return this.reportsAttribute.filter(report =>
      report.executiveName === executive
    )
  }

  getAutorizedPrice (inspection) {
    const { lastAppraisedResponse, lastAppraisedConsignmentResponse } = inspection
    const purchaseAmount = Number(lastAppraisedResponse?.amount)
    const consignmentAmount = Number(lastAppraisedConsignmentResponse?.amount)
    const publicationAmount = Number(inspection?.expectedPublicationAmount)
    return {
      purchase: purchaseAmount ? fixPrice(purchaseAmount) : 'N/A',
      consignment: consignmentAmount ? fixPrice(consignmentAmount) : 'N/A',
      publication: publicationAmount ? fixPrice(publicationAmount) : 'N/A',
    }
  }

  getData () {
    if (!this.reports) return
    let reports = this.reports.getInspectionFinancialReport
    if (!reports) return
    reports = reports.sort((prev, next) =>
      dayjs(prev.scheduledDate).diff(dayjs(next.scheduledDate))
    )
    this.reportsAttribute = reports
    const executives = []
    reports.forEach(report => {
      if (!executives.includes(report.executiveName)) {
        executives.push(report.executiveName !== '' ? report.executiveName : 'SIN EJECUTIVO')
      }
    })
    this.executives = executives
  }

  get investmentDetail () {
    const { reportsAttribute, isConsignment, filterByExecutive } = this
    if (!reportsAttribute.length) return

    const reports = this.idExecutive ? filterByExecutive(undefined, this.idExecutive) : reportsAttribute

    return {
      purchase: reports
        .filter(item => !isConsignment(item))
        .reduce((acc, item) => acc += Number(item.appraised), 0) || 0,
      consignment: reports
        .filter(isConsignment)
        .reduce((acc, item) => acc += Number(item.appraised), 0) || 0,
      total: reports
        .reduce((acc, item) => acc += Number(item.appraised), 0) || 0,
    }
  }

  get projectedUtilityDetail () {
    const { reportsAttribute, isConsignment } = this
    if (!reportsAttribute.length) return

    return {
      purchase: reportsAttribute
        .filter(item => !isConsignment(item))
        .reduce((acc, item) => acc += Number(item.projectedUtility), 0) || 0,
      consignment: reportsAttribute
        .filter(isConsignment)
        .reduce((acc, item) => acc += Number(item.projectedUtility), 0) || 0,
      total: reportsAttribute
        .reduce((acc, item) => acc += Number(item.projectedUtility), 0) || 0,
    }
  }

  @Watch('reports', { immediate: true, deep: true })
  @Debounce(500)
  onReportsChange () {
    this.getData()
  }
  }

